import { filterObjectValues } from 'helpers/filter'

import { LogisticCart } from 'models/logistic_cart'
import { IStatistic } from 'models/statistic'

import { downloadFileHandler } from 'shared/libs'

import api, { CreateLogisticCartTagType } from '../api'
import {
  CreateLogisticCart,
  GetLogisticCartsParams,
  GetLogisticCartsResponse,
  LogisticCartReportType,
  UpdateLogisticCartStatus,
} from './types'

export const logisticCartApi = api.injectEndpoints({
  endpoints: build => ({
    getLogisticCarts: build.query<
      GetLogisticCartsResponse,
      GetLogisticCartsParams
    >({
      query: params => ({
        url: `/web/logistic_cart/`,
        params: filterObjectValues(params),
        cache: 'no-store',
      }),
      providesTags: [CreateLogisticCartTagType],
    }),
    getLogisticCartById: build.query<LogisticCart, LogisticCart['id']>({
      query: id => ({
        url: `/web/logistic_cart/${id}/`,
      }),
      providesTags: [CreateLogisticCartTagType],
    }),
    createLogisticCart: build.mutation<LogisticCart, CreateLogisticCart>({
      query: body => ({
        method: 'post',
        url: '/web/logistic_cart/',
        body,
      }),
      invalidatesTags: [CreateLogisticCartTagType],
    }),
    editLogisticCart: build.mutation<
      LogisticCart,
      { id: number; body: CreateLogisticCart }
    >({
      query: ({ id, body }) => ({
        method: 'put',
        url: `/web/logistic_cart/${id}/`,
        body,
      }),
      invalidatesTags: [CreateLogisticCartTagType],
    }),
    logisticCartStatistics: build.query<
      Array<IStatistic>,
      GetLogisticCartsParams
    >({
      query: params => ({
        url: `/web/logistic_cart/statistics/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60,
    }),
    updateLogisticCartStatus: build.mutation<void, UpdateLogisticCartStatus>({
      query: ({ id, body }) => ({
        method: 'put',
        url: `/web/logistic_cart/${id}/`,
        body,
      }),
      invalidatesTags: [CreateLogisticCartTagType],
    }),
    downloadLogisticCartExcel: build.mutation<
      void,
      { params: GetLogisticCartsParams; type?: LogisticCartReportType }
    >({
      query: ({ params, type = LogisticCartReportType.DEFAULT }) => ({
        url: `/web/logistic_cart/${type}/`,
        params: filterObjectValues(params),
        responseHandler: downloadFileHandler,
        cache: 'no-cache',
      }),
    }),
  }),
})
